import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import VueAwesomeSwiper from 'vue-awesome-swiper/dist/ssr'

// import 'swiper/dist/css/swiper.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import './assets/style/common.less'
import {initImgPreview} from "@/utils/previewImg";
initImgPreview()

Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI);

Vue.config.productionTip = false
function debounce(fn, delay = 100) {
    let timer = null;
    return () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn();
        }, delay);
    };
}

window.addEventListener('resize', debounce(() => {
    store.dispatch('updateMobileStatus');
}));
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
